import React, { useState, useEffect, useRef } from 'react';

import { motion } from 'framer-motion';
import ShimmerViewMore from './shimmer';
import Icon, { IconName } from '@utilities/icon';
import { DoctorProfile } from '@models/ocs/doctor';

interface ViewMoreProps {
  icon?: IconName;
  title?: string;
  aboutDoctor?: string;
  isLoading?: boolean;
}

const ViewMore = ({ title, aboutDoctor, isLoading = false }: ViewMoreProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (textRef.current) {
      const naturalHeight = textRef.current.scrollHeight;
      setContentHeight(naturalHeight);
      setIsOverflowing(naturalHeight > 100);
    }
  }, [aboutDoctor]);

  if (isLoading) return <ShimmerViewMore />;

  return (
    <div className="flex flex-col gap-y-2 px-4">
      <>
        <motion.div
          className="flex flex-col gap-y-4 overflow-hidden"
          initial={false}
          animate={{ height: isOpen ? contentHeight : 90 }}
          transition={{ duration: 0.3 }}
        >
          <div ref={textRef} className="flex flex-col gap-y-4 pb-2">
            <>
              <div className="flex flex-col justify-start">
                <span className="text-Headline/xSmall text-content-primary">
                  {title}
                </span>
              </div>

              <div className={`text-Body/xSmall text-content-secondary mb-2`}>
                <span>{aboutDoctor}</span>
              </div>
            </>
          </div>
        </motion.div>

        {isOverflowing && (
          <div className="flex justify-center pb-2">
            <button
              className="text-Body/Small text-content-primary font-semibold text-center"
              onClick={() => setIsOpen(!isOpen)}
              type="button"
            >
              <div className="flex gap-x-1 items-center">
                <span>{isOpen ? 'نمایش کمتر' : 'نمایش بیشتر'}</span>
                <Icon
                  name={isOpen ? 'ChevronUp' : 'ChevronDown'}
                  width={1}
                  height={1}
                />
              </div>
            </button>
          </div>
        )}
      </>
    </div>
  );
};

export default ViewMore;
